module.exports = __webpack_public_path__ + "img/kort-5.af769de4.jpg";